export default __webpack_public_path__ + "media/images/affaire_etape-planif-76889f53140db8778f324a743e69547d.png";